import { I18nKey } from "../../../infrastructure/ui/shared/types";

enum FeatureIds {
  TOP_TYPE = "0ccb5374-db8c-4dbb-afae-6b2652af170d",
  OUTSIDE_TYPE = "90d5a219-a892-411e-ba25-7244fa1e220c",
  PRINT = "c67b06b1-1c40-42a5-b029-e70533146b9f",
  NECKLINE = "aebb8442-3325-470f-a76e-fbd9c5596d3d",
  DETAIL = "5645397a-9858-4e4a-9e06-acbadd463738",
  CLOSING = "2e2a28f9-566d-419f-9081-cc9061324110",
  SKIRT_TYPE = "23da088e-f468-4beb-abc7-60397ae512ed",
  DOWN_PART_TYPE = "c4ca680b-8672-4ff5-8ba8-f2e4094e6b60",
  SHOT = "5ba43df1-ef52-48e7-aa30-83492df0c194",
  DRESS_TYPE = "273c5d63-83f2-4f88-9841-15b99e5ee1a1",
  JUMP_SUIT_TYPE = "1fe4b964-e430-44b9-9f6e-073351b8df88",
  NECK = "083021ee-4f31-4175-b071-9f4883c84a53",
  SHOE_TYPE = "7298588f-755b-4951-9ddb-9ef63b924e1f",
  TOECAP = "d6f40fcf-5757-47a8-b7c5-469fba5289e5",
  SOLE_TYPE = "395d4d49-a7b1-4e8a-8948-bc18beef1e44",
  HEEL_TYPE = "f0b53b00-1374-4fcc-85be-4ee811615a42",
  BAG_TYPE = "83fc5808-9319-444b-a84e-a6ac4a8da9aa",
  FOULARD_TYPE = "befc364a-c636-4c58-a43b-13e0e278b291",
  //
  FIT = "269f2901-47ea-4485-9808-8293f11b831b",
  LONG_CM = "51ac9ecd-7b74-4543-ac0c-4fe229da05a8",
  SLEEVE_LONG_CM = "a772aec6-6c85-4169-b8ef-4ab0d132453d",
  SIZING = "ae2da038-0e80-464e-a334-197e65d06c18",
  TYPE_OF_LENGTH = "38453e1-5526-4f8b-8dd3-b5c5480d50df",
  HEEL_LENGTH = "bef6d1f-f2c3-4ae7-8145-ffef4013324a",
  LEG_LENGTH = "35095baf-b444-43bd-aedf-9360be23ab6d",
  //
  FABRIC = "3299a9a7-d387-4ffb-bb7d-fece852611f6",
  COMPOSITION = "c512d2ea-9d34-436a-909e-c4a70e1af07a",
  GARMENT_CARE = "26951f65-6bdf-4350-8ce9-e1737e825e77",
  //
  MILD_WASH_30 = "e2528e92-b63f-40b1-b618-0f5ed1d22e1b",
  VERY_MILD_WASH_30 = "fa523a91-21cd-4416-9c35-867ae17bf69a",
  WASH_30 = "3d1b7213-b90f-45f6-8420-85625f7a15de",
  MILD_WASH_40 = "dcb7dd85-ec07-4d1e-9b35-433ffa376d55",
  VERY_MILD_WASH_40 = "4ad8ba8b-6f78-4856-b370-c47aec3f2722",
  WASH_40 = "f864aeaa-c528-44a8-ab5a-2bad69195a4e",
  MILD_WASH_60 = "b5704204-53fe-49ec-b853-74c98ff312fe",
  WASH_60 = "84a71216-ee4b-4306-9471-56e1a6d7a0d0",
  WASH_70 = "1145062f-1fd7-4ad1-82a7-e78644b0a759",
  WASH_95 = "fa67ac0a-68f6-4918-af17-23031a26be5e",
  ANY_BLEACH_ALLOWED = "ec9a29f9-83a1-4402-9c8b-d69f719d154a",
  DO_NOT_BLEACH = "7752d01c-27bf-48b3-b092-6086b49e9883",
  DO_NOT_DRY_CLEAN = "cb0530a8-4b25-4d0b-8b88-3d862f3d6de8",
  DO_NOT_IRON = "b0a23cbb-0cf9-45ea-a8ab-09296bfd582c",
  DO_NOT_TUMBLE_DRY = "2ac8cd46-aa62-4be5-9de6-ed759ee424d0",
  DO_NOT_WASH = "0899f37c-1850-4c23-8130-2f7a1e8669a9",
  DO_NOT_WET_CLEAN = "53fbe793-d029-4ffc-98eb-a5a0d9d602c3",
  DRIP_FLAT_DRYING = "094eaa93-a024-4a40-8d8e-531cc0cbc179",
  DRIP_FLAT_DRYING_IN_THE_SHADE = "048404c7-2f05-4649-a917-cad8164f09dc",
  DRIP_LINE_DRYING = "34624342-e5ea-4bef-bbf7-844dff541bbf",
  DRIP_LINE_DRYING_IN_THE_SHADE = "795d2e9a-bed0-4c8d-be1f-7a30fde85d57",
  FLAT_DRYING = "024df398-10fd-4315-bfc9-7dff650c9152",
  FLAT_DRYING_IN_THE_SHADE = "c7971054-d0d2-48a6-a445-420280e6861c",
  HAND_WASH = "814fe9f9-4a8c-4cf0-847e-8c5b20bf5797",
  IRON_AT_HIGH_TEMPERATURE = "c431ec3e-3711-4a89-a13c-8649a78c1a01",
  IRON_AT_LOW_TEMPERATURE = "a8808ee4-8735-42cf-bdac-defb6b9e334a",
  IRON_AT_MODERATE_TEMPERATURE = "dfeee14a-b7ee-47fa-9d22-4aaaaee76a23",
  LINE_DRYING = "dc714ff3-54be-419b-8122-02f591bd9c4f",
  LINE_DRYING_IN_THE_SHADE = "8a0e2b5e-5b9e-4b9e-8b9e-9b0b6b5b2b9e",
  MILD_PROFESSIONAL_WET_CLEAN = "f44d0728-a06f-49f9-8f9d-2c540078c1ae",
  MILD_TUMBLE_DRY = "c7e4646e-ba89-4625-841c-c240b2b35b7c",
  NORMAL_TUMBLE_DRY = "60154675-f506-48c3-a358-9cb729011116",
  ONLY_OXYGEN_BLEACH_ALLOWED = "3392c299-f03f-4309-93bd-8427d702f185",
  PROFESSIONAL_DRY_CLEAN_IN_HYDROCARBONS = "f0b88bb8-22d1-4542-bb9c-5ba955a19c64",
  PROFESSIONAL_DRY_CLEAN_IN_PERCHLOROETHYLENE = "a5661acb-aec6-4b67-8077-a0b714e29954",
  PROFESSIONAL_MILD_DRY_CLEAN_IN_HYDROCARBONS = "a7b5cef8-c26b-4043-acff-3fb8b14aa518",
  PROFESSIONAL_MILD_DRY_CLEAN_IN_PERCHLOROETHYLENE = "a4c0ff40-259f-40d8-a4b1-4408271ff075",
  PROFESSIONAL_WET_CLEAN = "1c5b83b4-09b7-4db7-b272-646952800b9f",
  VERY_MILD_PROFESSIONAL_WET_CLEAN = "66f0a065-97cc-4edc-a674-4e909668a252",
}

interface QualifierValue {
  readonly key: string;
}

interface Qualifier {
  readonly qualifierValues: QualifierValue[];
  readonly name: string;
  readonly type: string;
}

interface FeatureValue {
  readonly id: string;
  readonly key: I18nKey;
  readonly qualifier?: Qualifier;
}

interface Feature {
  readonly id: string;
  readonly key: I18nKey;
  readonly featureValues: FeatureValue[];
}

export type { Feature, Qualifier };
export { FeatureIds };
